module.exports = __webpack_public_path__ + "media/images/niq-settings-95f051ca63ac44a21cd5307f69713447.svg";